import AdminRecordings from "@/pages/admin/AdminRecordings";

export default function PmRecordings() {
  return <AdminRecordings endpoint="/pm/call-recordings" tabs={false} subtitle="Every recorded Ava call to your leads, with its AI summary." />;
}
